import { createContext, Dispatch } from 'react'
import { StepAction } from '../hooks/useStepReducer/useStepReducer'
import { SimulationAction } from '../hooks/useSimulationReducer/useSimulationReducer'

interface SimulatorDispatchContextProps {
  stepDispatch: Dispatch<StepAction>
  simulationDispatch: Dispatch<SimulationAction>
}

const SimulatorDispatchContext = createContext<SimulatorDispatchContextProps>({
  stepDispatch: () => {},
  simulationDispatch: () => {}
})

export { SimulatorDispatchContext }
export type { SimulatorDispatchContextProps }
